export default "__VITE_ASSET__CX$0kNwX__"